import {createContext, useContext, RefObject} from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const RecaptchaContext = createContext<RefObject<ReCAPTCHA> | undefined>(undefined);
const useRecaptchaContext = () => useContext(RecaptchaContext);

export {RecaptchaContext, useRecaptchaContext};
